"use client";

import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { trackEvent } from "@/lib/analytics";

// Cross-promo strip for the next live webinar. Dropped into the /burnout topic
// page and the /teste/burnout test page. Details live here so both placements
// stay in sync; point it at the next event when this one is over, or remove the
// two usages if there is no next event.
const NEXT_WEBINAR = {
  href: "/webinar-limite",
  title: "De ce este atât de greu să punem limite?",
  when: "Miercuri, 30 septembrie · 19:00 · online, gratuit",
};

export default function WebinarBanner({ location }: { location: string }) {
  return (
    <section className="px-5 py-5 lg:px-10">
      <Link
        href={NEXT_WEBINAR.href}
        onClick={() => trackEvent("webinar_banner_click", { location, webinar: "limite" })}
        className="group mx-auto flex max-w-4xl flex-col gap-4 border-y border-[#264653]/12 py-5 sm:flex-row sm:items-center sm:justify-between sm:gap-8"
      >
        <div>
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#2C969B]">
            Webinar gratuit
          </p>
          <p className="mt-2 font-serif text-[19px] font-medium leading-snug text-[#264653] sm:text-[21px]">
            {NEXT_WEBINAR.title}
          </p>
          <p className="mt-1.5 text-[14px] text-[#264653]/60">{NEXT_WEBINAR.when}</p>
        </div>
        <span className="inline-flex h-12 shrink-0 items-center justify-center gap-2 rounded-lg bg-[#DC7050] px-7 text-[15px] font-semibold text-white transition-colors group-hover:bg-[#c25c3e]">
          Rezervă locul
          <ArrowRight className="size-4 transition-transform group-hover:translate-x-0.5" />
        </span>
      </Link>
    </section>
  );
}
